import { Checkbox, Space } from 'antd';
import { type FC } from 'react';

import { ArchiveLabel } from '@app/shared/components';
import type { MultiSelectOption } from '@app/shared/components/MultiSelect/types';

import type { CheckboxChangeEvent } from 'antd/lib';

const PF = 'multi-select';

interface MultiSelectOptionRowProps {
  option: MultiSelectOption;
  checked: boolean;
  optionDataTestId: string;
  activeCheckboxDataTestId: string;
  deactivateCheckboxDataTestId: string;
  onToggle(value: string, checked: boolean): void;
  renderOptionLabel(option: MultiSelectOption): string;
}

export const MultiSelectOptionRow: FC<MultiSelectOptionRowProps> = ({
  option,
  checked,
  optionDataTestId,
  activeCheckboxDataTestId,
  deactivateCheckboxDataTestId,
  onToggle,
  renderOptionLabel,
}) => {
  const label = renderOptionLabel(option);

  const changeHandler = ({
    target: { checked: nextChecked },
  }: CheckboxChangeEvent) => {
    onToggle(option.value, nextChecked);
  };

  return (
    <label
      className={`${PF}__option`}
      data-testid={optionDataTestId}
      title={label}
    >
      <Checkbox
        disabled={option.disabled}
        checked={checked}
        data-testid={
          checked ? activeCheckboxDataTestId : deactivateCheckboxDataTestId
        }
        onChange={changeHandler}
      />
      <span
        className={`${PF}__option__label${
          option.isDeleted ? ` ${PF}__option__label--deleted` : ''
        }`}
      >
        <Space size={8} align="center">
          {option.isDeleted && <ArchiveLabel />}
          {option.label}
        </Space>
      </span>
    </label>
  );
};
